import { Shimmer } from "../styles"

export const PageLoaderForm = () => {
    return (
        <div style={{paddingInline: '30px'}}>
            <Shimmer style={{marginTop: '32px', height: '103px', paddingInline: '30px'}}></Shimmer>
            <Shimmer style={{marginTop: '32px', height: '276px', paddingInline: '30px'}}></Shimmer>
        </div>
    )
}